import React from 'react';
import addToMailchimp from 'gatsby-plugin-mailchimp';
import { useStaticQuery, graphql } from 'gatsby';
import {
  faEnvelope,
  faUser,
  faNewspaper,
} from '@fortawesome/pro-light-svg-icons';
import { faPaperPlaneTop } from '@fortawesome/pro-solid-svg-icons';
import { getImage, GatsbyImage } from 'gatsby-plugin-image';
import config from '../../../meta/config';
import { StyledNewsletter } from './styles';
import { useStateValue } from '../../state';
import { Text } from '../Text/index';
import { Button } from '../Button/index';
import { WidgetTitle } from '../WidgetTitle/index';
import { Input } from '../Input';

const { heading, description, buttonText } = config.newsletter;
interface INewsletter {
  id?: any;
  topRadiusFlat?: boolean;
  className?: string;
  hor?: boolean;
  forceVert?: boolean;
}

export const Newsletter = ({
  topRadiusFlat = false,
  id,
  className,
  hor = false,
  forceVert = false,
}: INewsletter) => {
  const [{ newsletterState }, dispatch] = useStateValue();
  const { submitted, responseMsg } = newsletterState;
  const nameFieldRef = React.useRef({ value: `` });
  const emailFieldRef = React.useRef({ value: `` });
  const { newsletterSuccessImage } = useStaticQuery(graphql`
    query NewsletterSuccessImage {
      newsletterSuccessImage: contentfulAsset(
        contentful_id: { eq: "18PCPTAzlOiHiGNFl8gOX1" }
      ) {
        gatsbyImageData(
          width: 200
          height: 150
          quality: 85
          placeholder: BLURRED
        )
      }
    }
  `);

  const newsLetterImage = getImage(newsletterSuccessImage);

  function handleError() {
    dispatch({
      type: `newsletterResetError`,
      newErrorState: { isError: false },
    });
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    handleError();
    const { result, msg } = await addToMailchimp(emailFieldRef.current.value, {
      ID: id,
      FULLNAME: nameFieldRef.current.value,
    });

    if (result === `success`) {
      dispatch({
        type: `newsletterSubmitted`,
        newSubmittedState: {
          submitted: true,
          responseMsg: msg,
        },
      });
      return;
    }
    dispatch({
      type: `newsletterError`,
      newSubmittedState: {
        submitted: false,
        responseMsg: msg,
      },
      newErrorState: { isError: true },
    });
  };

  return (
    <StyledNewsletter
      topRadiusFlat={topRadiusFlat}
      hor={hor}
      forceVert={forceVert}
      className={`${className} newsletter`}
    >
      {submitted ? (
        <>
          <Text type="body1" tag="p" color="white_1">
            {responseMsg}
          </Text>
          <GatsbyImage image={newsLetterImage} alt="newsletter success image" />
        </>
      ) : (
        <>
          <div className="newsletter__header">
            <WidgetTitle icon={faNewspaper}>{heading}</WidgetTitle>
          </div>
          <div className="newsletter__content">
            <Text className="newsletter__text" type="body3" tag="p" noRhythem>
              {description}
            </Text>
            <form id={id} onSubmit={handleSubmit} className="newsletter__form">
              <Input
                refTo={nameFieldRef}
                className="newsletter__input-user"
                type="text"
                icon={faUser}
                placeholder="full name..."
                name="newsletter-name"
              />
              <Input
                refTo={emailFieldRef}
                className="newsletter__input-email"
                type="email"
                icon={faEnvelope}
                placeholder="email..."
                name="newsletter-email"
              />
              <Button
                className="newsletter__button"
                size="large"
                iconRight={faPaperPlaneTop}
                disabled={false}
              >
                {buttonText}
              </Button>
            </form>
          </div>
        </>
      )}
    </StyledNewsletter>
  );
};
